package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("CreateNewPublicPlanRequest")
data class CreateNewPublicPlanRequest(
    @JsName("initialPlanDefinitionId")
    val initialPlanDefinitionId: String
)